import EditableRichText, { resolveTextHtml } from 'src/common/components/EditableRichText';
import { usePublicPageEdit } from 'src/common/components/PublicPageEditContext';
import PageBlockShell from 'src/common/components/page-blocks/PageBlockShell';
import { LanguageKeys } from 'src/common/constants/languages';
import { frostedHeroTextSx } from 'src/common/styles/frostedPanelStyles';
import { PlaceholderRenderContext } from 'src/helpers/placeholderRegistry';
import { ITextBlock } from 'src/interfaces/PageBlock';

interface Props {
  block: ITextBlock;
  lang: LanguageKeys;
  placeholderContext: PlaceholderRenderContext;
  inHero?: boolean;
}

export default function TextBlockContent({ block, lang, placeholderContext, inHero }: Props) {
  const edit = usePublicPageEdit();
  const isEditMode = edit?.isEditMode ?? false;
  const displayLang = isEditMode && edit ? edit.selectedEditorLang : lang;
  const html = resolveTextHtml(block.i18n ?? ({} as ITextBlock['i18n']), displayLang);

  if (!html.trim() && !isEditMode) return null;

  const useFrosted = inHero && block.frostedBackground === true;

  const shellSx = {
    ...(inHero
      ? {
          fontSize: '1.2rem',
          fontWeight: 'medium',
          fontFamily: ['JetBrains Mono', 'monospace'].join(','),
          ...(useFrosted
            ? {
                borderRadius: 2,
                px: { xs: 2, sm: 2.5, md: 3 },
                py: { xs: 1.5, sm: 2, md: 2.5 },
                ...frostedHeroTextSx(),
              }
            : {}),
        }
      : { mb: 2 }),
  };

  return (
    <PageBlockShell sx={shellSx}>
      <EditableRichText
        blockId={block.id}
        html={html}
        placeholderContext={placeholderContext}
        showWhenEmpty={isEditMode}
      />
    </PageBlockShell>
  );
}
